import { useEffect, useState } from 'react';
import { useIdleTimer } from 'react-idle-timer';
import { useNavigate } from 'react-router';
import { setGlobalState, useGlobalState } from 'src/state/globalstate';
import { captureLogout } from 'src/common/analytics';

function IdleTimer() {
  let navigate = useNavigate();
  const [loggedin] = useGlobalState('loggedin');

  // Set timeout values
  const timeout = 1000 * 60 * 30; // 30 minutes

  const promptTimeout = 100;
  const crosstab = false;

  // Modal open state
  const [open, setOpen] = useState(false);

  // Time before idle
  const [remaining, setRemaining] = useState(0);

  const onPrompt = () => {
    // onPrompt will be called after the timeout value is reached
    // In this case 30 minutes. Here you can open your prompt.
    setOpen(true);
    setRemaining(promptTimeout);
  };

  const onIdle = () => {
    // Log out and redirect to login page if idle
    captureLogout('idle_timeout');
    const selectedLanguage = localStorage.getItem('language');
    const languageType = localStorage.getItem('languageType');
    localStorage.clear();
    localStorage.setItem('language', selectedLanguage);
    localStorage.setItem('languageType', languageType);
    navigate('/login');
    setGlobalState('loggedin', false);
    setGlobalState('sessionerror', 'Unauthorized');
    setOpen(false);
    setRemaining(0);
  };

  const onActive = () => {
    // Reset modal and remaining time when active again
    setOpen(false);
    setRemaining(0);
  };

  const onAction = () => {
    // Update expiration time on user activity
    const time = Date.now();
    localStorage.setItem('Expiretime', String(time));
    setOpen(false);
    setRemaining(0);
  };

  const { getRemainingTime, isPrompted, reset } = useIdleTimer({
    timeout,
    crossTab: true,
    promptTimeout,
    onPrompt,
    onIdle,
    onActive,
    onAction
  });

  const handleStillHere = () => {
    // Reset the idle timer when user is still here
    setOpen(false);
    reset();
  };

  useEffect(() => {
    const checkSessionExpiration = () => {
      const expireTime = localStorage.getItem('Expiretime');
      if (expireTime) {
        const currentTime = Date.now();
        if (currentTime - parseInt(expireTime) > timeout) {
          // If session is expired, log out the user
          captureLogout('session_expired');
          localStorage.clear();
          setGlobalState('loggedin', false);
          setGlobalState('sessionerror', 'Unauthorized');
          navigate('/login');
        }
      }
    };

    checkSessionExpiration(); // Check on component mount

    // Set an interval to check if the user is idle and update the remaining time
    const interval = setInterval(() => {
      if (isPrompted()) {
        setRemaining(Math.ceil(getRemainingTime() / 1000));
      }
    }, 1000);

    return () => {
      clearInterval(interval);
    };
  }, [getRemainingTime, isPrompted, navigate]);

  return (
    <>
      <div> </div>
    </>
  );
}

export default IdleTimer;